import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgStats extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string,
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e',
    };
    render() {
        const { color, size } = this.props;
        return (
            <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" height={size} viewBox="0 0 459.75 459.75">
                <path
                    fill={color}
                    d="M447.652 304.13h-40.138c-6.681 0-12.097 5.416-12.097 12.097v95.805c0 6.681 5.416 12.098 12.097 12.098h40.138c6.681 0 12.098-5.416 12.098-12.098v-95.805c0-6.681-5.416-12.097-12.098-12.097zM348.798 258.13H308.66c-6.681 0-12.098 5.416-12.098 12.097v141.805c0 6.681 5.416 12.098 12.098 12.098h40.138c6.681 0 12.097-5.416 12.097-12.098V270.228c.001-6.682-5.415-12.098-12.097-12.098zM151.09 304.13h-40.138c-6.681 0-12.097 5.416-12.097 12.097v95.805c0 6.681 5.416 12.098 12.097 12.098h40.138c6.681 0 12.098-5.416 12.098-12.098v-95.805c0-6.681-5.417-12.097-12.098-12.097zM52.236 258.13H12.098C5.416 258.13 0 263.546 0 270.228v141.805c0 6.681 5.416 12.098 12.098 12.098h40.138c6.681 0 12.097-5.416 12.097-12.098V270.228c0-6.682-5.416-12.098-12.097-12.098zM249.944 196.968h-40.138c-6.681 0-12.098 5.416-12.098 12.098v202.967c0 6.681 5.416 12.098 12.098 12.098h40.138c6.681 0 12.098-5.416 12.098-12.098V209.066c0-6.682-5.417-12.098-12.098-12.098z"
                />
                <path
                    fill={color}
                    d="M436.869 244.62c8.14 0 15-6.633 15-15v-48.479c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15v12.119L269.52 40.044a14.986 14.986 0 0 0-11.989-4.362 15.004 15.004 0 0 0-11.011 6.445L131.745 209.185 30.942 144.969c-6.987-4.451-16.26-2.396-20.71 4.592-4.451 6.987-2.396 16.259 4.592 20.71l113.021 72a14.939 14.939 0 0 0 8.046 2.351 14.99 14.99 0 0 0 12.376-6.507l112.736-164.09L400.8 214.62h-12.41c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15h48.479z"
                />
            </svg>
        );
    }
}
export default withTheme(SvgStats);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgStats.js